import { render, staticRenderFns } from "./TheTopbar.vue?vue&type=template&id=2c4fc9dc&"
import script from "./TheTopbar.vue?vue&type=script&lang=js&"
export * from "./TheTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports